import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiResponse, PackageUIResponse } from "../../models/ApiResponse";
import agent from "../../api/agent";
import { PackageResponse } from "../../models/responseModels/packageResponse";
// import {
//   AddPackageRequest,
//   UpdatePackageRequest,
// } from "../../models/requestModels/packageRequest";

type InitialState = {
  isLoading: boolean;
  packageList: PackageResponse[];
  errorMessage: string | null;
};

const initialState: InitialState = {
  isLoading: false,
  packageList: [],
  errorMessage: null,
};

export const getPackageList = createAsyncThunk<PackageUIResponse>(
  "package/packageResponse",
  async () => {
    const response = await agent.PackageAgent.getPackageList();
    return response;
  }
);

// export const downloadPackageDataToCsv = createAsyncThunk<
//   PackageDownloadResponse,
//   PackageResponse[]
// >("package/downloadCsv", async (packagesData: PackageResponse[]) => {
//   const response = await agent.PackageAgent.packageCsvDownload(packagesData);
//   return response;
// });

export const downloadPackageDataToXlsx = createAsyncThunk<
  Blob,
  PackageResponse[]
>("package/downloadXlsx", async (packagesData: PackageResponse[]) => {
  const response = await agent.PackageAgent.packageXlsxDownload(packagesData);
  return response;
});

// export const updatePackage = createAsyncThunk<
//   ApiResponse,
//   UpdatePackageRequest
// >(
//   "package/updatePackage",
//   async (updatePackageRequest: UpdatePackageRequest) => {
//     const response = await agent.PackageAgent.updatePackage(
//       updatePackageRequest
//     );
//     return response;
//   }
// );

// export const addPackage = createAsyncThunk<ApiResponse, AddPackageRequest>(
//   "package/addPackage",
//   async (addPackageRequest: AddPackageRequest) => {
//     const response = await agent.PackageAgent.addPackage(addPackageRequest);
//     return response;
//   }
// );

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPackageList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPackageList.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.packageList = action.payload.data;
        } else {
          state.packageList = [];
        }
      })
      .addCase(getPackageList.rejected, (state, action) => {
        state.isLoading = false;
        state.packageList = [];
        state.errorMessage = action.error.message!;
      });
  },
});

export default packageSlice.reducer;
